export default __webpack_public_path__ + "media/blueberries-large.187a677e0dafa43f23e8624493b40046.webp";